import { get, post, put, del /*, upload */ } from '@api/request';
import queryString from 'query-string';

export async function searchDockets(
  { appealsService },
  authenticationToken,
  { query },
) {
  const params = queryString.stringify(query);
  const url = `${appealsService}/prodigyappeals/appealdockets?${params}`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function copyDocketToDateRange(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/copy`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealLocations(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/appeallocations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealLocation(
  { appealsService },
  authenticationToken,
  { locationId },
) {
  const url = `${appealsService}/prodigyappeals/appeallocation/${locationId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertAppealLocation(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeallocations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealLocation(
  { appealsService },
  authenticationToken,
  { locationId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appeallocation/${locationId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteAppealLocation(
  { appealsService },
  authenticationToken,
  { locationId },
) {
  const url = `${appealsService}/prodigyappeals/appeallocation/${locationId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function createAppealDocket(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdockets`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function increaseDocketCapacity(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/timeslotsincreasecapacity`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function changeDocketCapacity(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/timeslotschangecapacity`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function closeDocket(
  { appealsService },
  authenticationToken,
  { payload, docketId },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/finalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massCloseDocket(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/massclose`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateAppealDocket(
  { appealsService },
  authenticationToken,
  { docketId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAllDocketTimeSlots(
  { appealsService },
  authenticationToken,
  { docketId },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/timeslots`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createDocketTimeSlot(
  { appealsService },
  authenticationToken,
  { docketId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/timeslots`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteDocketTimeSlot(
  { appealsService },
  authenticationToken,
  { docketTimeslotId },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/timeslot/${docketTimeslotId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function clearDocketTimeSlot(
  { appealsService },
  authenticationToken,
  { docketId },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/cleartimeslots`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function clearAgentReservation(
  { appealsService },
  authenticationToken,
  { docketTimeSlotID },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/timeslot/${docketTimeSlotID}/clearagentreservation`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchTimeSlotScheduled(
  { appealsService },
  authenticationToken,
  { docketTimeSlotID },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/timeslot/${docketTimeSlotID}/timeslotscheduled`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function finalizeDocket(
  { appealsService },
  authenticationToken,
  { docketId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/finalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteDocket(
  { appealsService },
  authenticationToken,
  { docketId },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function reopenDocket(
  { appealsService },
  authenticationToken,
  { docketId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/reopen`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyDocketGroups(
  { appealsService },
  authenticationToken,
  { docketId },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/propertydocketgroups`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertPropertyDocketGroup(
  { appealsService },
  authenticationToken,
  { docketId, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/${docketId}/propertydocketgroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deletePropertyDocketGroup(
  { appealsService },
  authenticationToken,
  { docketGroupId },
) {
  const url = `${appealsService}/prodigyappeals/appealdocket/propertydocketgroup//${docketGroupId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function searchAppealDocketTimeslots(
  { appealsService },
  authenticationToken,
  { query },
) {
  const params = queryString.stringify(query);
  const url = `${appealsService}/prodigyappeals/appealdockettimeslots?${params}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function massAppealsScheduler(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/appeal/scheduler`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealsSchedulerStatus(
  { appealsService },
  authenticationToken,
  { scheduleId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/schedule/${scheduleId}/status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealsSchedulerErrors(
  { appealsService },
  authenticationToken,
  { scheduleId },
) {
  const url = `${appealsService}/prodigyappeals/appeal/schedule/${scheduleId}/errors`;
  const { body } = await get(authenticationToken, url);
  return body;
}
